import {
  type PimProductV11,
  PimProductV1StockStatusEnum,
} from '@redteclab/api/clients/bully'

import { PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS } from './productAccessorGetOutOfStockMessageDays'

/**
 * stock status of a product maybe available, but it may be not on stock.
 * in this case out_of_stock_message will contain a message in how many days it will be deliverable.
 *
 * e.g.
 * stock_status: 'available'
 * out_of_stock_message: 'product.notOnStock.delivery.3_5'
 *
 * means, product will be shipped in 3-5 days, and the appropriate message shall be shown.
 */
export const productAccessorStockIsAvailableButHasNotOnStockMessage = (
  product: PimProductV11,
): boolean => {
  const isAvailable =
    product.stock_status === PimProductV1StockStatusEnum.Available

  if (!isAvailable) {
    return false
  }

  return (
    product.out_of_stock_message?.includes(
      PRODUCT_NOT_ON_STOCK_DELIVERY_STATUS,
    ) ?? false
  )
}
